var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.6064C22 7.0836 17.5228 2.60645 12 2.60645C6.47715 2.60645 2 7.0836 2 12.6064C2 18.1292 6.47715 22.6064 12 22.6064",
    stroke: "#007755",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.65576C13 2.65576 16 6.60638 16 12.6063",
    stroke: "#007755",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22.557C11 22.557 8 18.6063 8 12.6063C8 6.60638 11 2.65576 11 2.65576",
    stroke: "#007755",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62964 16.1064H12",
    stroke: "#007755",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62964 9.10645H21.3704",
    stroke: "#007755",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8789 18.5239C22.3727 18.8276 22.3423 19.5669 21.8337 19.6246L19.2671 19.9155L18.1159 22.2278C17.8878 22.686 17.1827 22.4617 17.0661 21.8938L15.8108 15.7778C15.7123 15.2978 16.1437 14.9957 16.561 15.2525L21.8789 18.5239Z",
    stroke: "#007755",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/site.550921b44fe235d30a4c6aac5e261318.svg";
export { ForwardRef as ReactComponent };